module.exports = __webpack_public_path__ + "img/box3_img1.0438417a.png";